/** Same-origin sideload APK. Prod and QA each host their own file at this path. */
export const PDV_APK_PATH = '/ggrupos-pdv.apk'

export const PDV_APK_LABEL = 'Baixar app PDV (Android)'
